import React, { useState } from 'react';
import { IconButton, Popover, TextField, InputAdornment, Divider, Skeleton } from '@mui/material';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Edit, Search } from '@mui/icons-material';
import '../assets/styles/sass/FontAwesomeIconPicker.scss';
import { useFontAwesomeIconPack } from '../hooks/useFontAwesomeIconPack';
import { useTranslation } from "react-i18next";

const FontAwesomeIconPicker = ({ value, onChange }) => {
  const [searchText, setSearchText] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const iconPack = useFontAwesomeIconPack();
  const{t}=useTranslation();

  if (!iconPack) {
    return <Skeleton variant="rectangular" width={210} height={40} />;
  }

  const iconsFiltered = iconPack
  .filter((icon) => icon.iconName.toLowerCase().includes(searchText.toLowerCase()))
  .reduce((uniqueIcons, icon) => {
    if (!uniqueIcons.some((uniqueIcon) => uniqueIcon.iconName === icon.iconName)) {
      uniqueIcons.push(icon);
    }
    return uniqueIcons;
  }, []);




  return (
    <>
      <TextField
        fullWidth
        placeholder={t("SELECT_AN_ICON")}
        value={value}
        sx={{
          '& .MuiInputBase-root': {
            color: 'var(--text-color)', // Text color
            backgroundColor: 'var(--surface-ground) !important'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'grey', // Default border color
            },
            '&:hover fieldset': {
              borderColor: 'var(--primary-color)', // Hover border color
            },
            '&.Mui-focused fieldset': {
              borderColor: 'var(--primary-color)', // Focused border color
            },
          },
          '& .MuiInputLabel-root': {
            color: 'grey', // Label color
          },
          '& .MuiInputBase-input::placeholder': {
            color: 'var(--text-color)', // Placeholder color
            // opacity: 1,
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}
               sx={{
                color: 'var(--text-color)', // Icon color
              }}
                >
                {value ? (
                  <FontAwesomeIcon icon={['fas', value]} color="var(--primary-color)" />
                ) : (
                  <Edit fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          )
        }}
        variant="outlined"
        size="small"
      />
      <Popover
        className="iconPicker"
        id={anchorEl ? 'iconPickerPopover' : undefined}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        PaperProps={{
          className: 'iconPicker__paper'
        }}

      >
        <div className="iconPicker__popoverContainer" style={{position:"relative",zIndex:"999999"}}>
          <div className="iconPicker__popoverHeader">
            <TextField
              fullWidth
              placeholder="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                )
              }}
              size="small"
              variant="outlined"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <Divider />
          <div className="iconPicker__iconsContainer">
            {iconsFiltered.map((icon,index) => (
              <div className="iconPicker__iconWrapper" key={icon.index}>
                <button
                  className={`iconPicker__iconItem ${icon.iconName === value ? 'selected' : ''}`}
                  title={icon.iconName}
                  onClick={() => onChange?.(icon.iconName)}
                >
                  <FontAwesomeIcon icon={icon} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};

export default FontAwesomeIconPicker;
